module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4316e13b630726c2d52ad29277405b44"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
